import { Component, h, Event, Prop, Host, State, Watch, EventEmitter } from '@stencil/core'
import { v4 as uuidv4 } from 'uuid'
import { CheckboxButtonUpdatedEvent } from '../../utils/inputfields'

@Component({
  tag: 'snap-checkbox-button',
  styleUrl: 'snap-checkbox-button.scss',
})
export class SnapCheckboxButton {
  @Prop({ reflect: true }) label: string = ''
  @Prop({ reflect: true }) inputName: string = ''
  @Prop({ reflect: true, mutable: true }) id: string = ''
  @Prop({ reflect: true }) description: string = ''
  @Prop({ reflect: true }) value: string = ''
  @Prop({ reflect: true, mutable: true }) checked: boolean = false
  @Prop({ reflect: true }) checkboxSide: string = 'left'
  @Prop({ reflect: true }) descriptionInline: boolean = false
  @Prop({ reflect: true, mutable: true }) disabled: boolean = false
  @Prop({ reflect: true, mutable: true }) locked: boolean = false
  @Prop( { reflect: true }) noFocus: boolean = false

  private tabIndex = null

  @State() newId: string

  @Event({eventName: 'snap-checkbox-updated'}) snapCheckboxUpdated: EventEmitter<CheckboxButtonUpdatedEvent>

  updateId() {
    this.id === 'undefined' || this.id.trim() === '' ? (this.id = uuidv4()) : null
  }

  @Watch('checked')
  onCheckedChanged(value: boolean) {
    this.snapCheckboxUpdated.emit({
      checked: value,
      value: this.value,
    })
  }

  componentWillLoad() {
    if (this.locked) {
      this.disabled = true
      this.checked = true
    }

    this.noFocus ? this.tabIndex = -1 : null
  }

  onClick = (ev: any) => {
    ev.preventDefault()
    this.checked = !this.checked
  }

  render() {
    this.updateId()
    if (this.checkboxSide === 'left') {
      return (
        <Host
          class={{
            selected: this.checked,
            disabled: this.disabled
          }}
          onClick={this.onClick}>
          <div class="input-wrapper">
            <input
              id={this.id}
              aria-describedby={`${this.label}-description`}
              name={this.inputName}
              type="checkbox"
              value={this.value}
              checked={this.checked}
              disabled={this.disabled}
              tabIndex={this.tabIndex}
              class={`input ${this.locked ? 'locked' : ''}`}
            />
          </div>
          <div class="label-wrapper">
            <label htmlFor={this.id} class="label">
              {this.label}
            </label>
            {this.descriptionInline ? (
              <span id={`${this.id}-description`} class="description">
                <span>{this.label} </span>&nbsp;{this.description}
              </span>
            ) : (
              <p id={`${this.id}-description`} class="description">
                {this.description}
              </p>
            )}
          </div>
        </Host>
      )
    } else {
      return (
        <Host
          class={{
            selected: this.checked,
            disabled: this.disabled
          }}
          onClick={this.onClick}>
          <div class="label-wrapper right">
            <label htmlFor={this.id} class="label">
              {this.label}
            </label>
            {this.descriptionInline ? (
              <span id={`${this.id}-description`} class="description">
                <span>{this.label} </span>&nbsp;{this.description}
              </span>
            ) : (
            <p id={`${this.id}-description`} class="description">
              {this.description}
            </p>
            )}
          </div>
          <div class="input-wrapper">
            <input
              id={this.id}
              aria-describedby={`${this.id}-description`}
              name={this.inputName}
              type="checkbox"
              value={this.value}
              checked={this.checked}
              disabled={this.disabled}
              tabIndex={this.tabIndex}
              class={`input ${this.locked ? 'locked' : ''}`}
            />
          </div>
        </Host>
      )
    }
  }
}
